//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
"vux";
import { mapState } from "vuex";

import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";

export default {
  data() {
    return {
      value: "",
      headerId: this.$route.query.noticeHeaderId,
      headerInfo: {},
      items: [],
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
    }),
  },
  created() {
    this.requestHeader();
    this.requestItems();
  },
  activated: function () {},
  methods: {
    requestHeader() {
      fetch
        .noticeFindById({
          lan: this.languageCode,
          noticeHeaderId: this.$route.query.noticeHeaderId,
        })
        .then((res) => {
          console.log(res);
          if (res.status === "S") {
            if (res.status === "S") {
              this.headerInfo = res.data;
            }
          }
        });
    },
    requestItems() {
      fetch
        .listByPageToMobile({
          lan: this.languageCode,
          noticeHeaderId: this.$route.query.noticeHeaderId,
        })
        .then((res) => {
          console.log(res);
          if (res.status === "S") {
            if (res.status === "S") {
              this.items = res.data;
            }
          }
        });
    },
  },
  watch: {},
  mounted() {
    console.log(this.$route.query.noticeHeaderId);
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/delivery/notice.vue